<template>
	<div class="register" :class="{'customBg': clientRegister && clientRegister.custom_bg }" :style="clientRegister && clientRegister.custom_bg ? {'background-image': 'url(' + $apiUrl + '/storage/' + clientRegister.custom_bg + ')'} : {}">
		<div class="language-picker">
		    <span :class="{active: $store.state.globalLanguage === 'en'}" @click="setLanguage('en')">EN</span>
		    <span :class="{active: $store.state.globalLanguage === 'sv'}" @click="setLanguage('sv')">SV</span>
		</div>

		<v-dialog v-model="alreadyExists" width="500">
			<v-card>
				<v-card-title class="text-h5 grey lighten-2">Användare finns redan</v-card-title>

				<v-card-text>
					<div class="py-3" v-html="clientRegister && clientRegister.email_already_exists ? clientRegister.email_already_exists : null"></div>
				</v-card-text>

				<v-divider></v-divider>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="alreadyExists = false">Stäng</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>


		<div class="register-container mt-md-10" v-if=" ! thanks">
			<h2>{{ clientRegister && clientRegister.title ? clientRegister.title : clientTitle }}</h2>

			<h3 class="mt-5" v-html="clientRegister && clientRegister.text_below_title ? clientRegister.text_below_title : __('register_under_title', 'Get access to the Smart Travel Habits platform by entering your information below')"></h3>

			<h4 class="mb-2 mt-10" :class="{hasError: errors.includes('firstName')}">{{ __('register_first_name', 'First name') }}</h4>
			<v-text-field hide-details solo v-model="firstName"></v-text-field>

			<h4 class="mb-2 mt-5" :class="{hasError: errors.includes('email')}">{{ __('register_email', 'E-mail') }}</h4>
			<v-text-field class="mb-8" hide-details solo v-model="email"></v-text-field>

			<div class="d-md-flex">
				<v-checkbox hide-details v-model="consent">
					<template v-slot:label>
						<span :class="{hasError: errors.includes('consent')}">
							<span class="consent-text" v-html="clientRegister && clientRegister.consent_text ? clientRegister.consent_text : ''"></span>
						</span>
					</template>
				</v-checkbox>

				<div>
					<div style="min-width: 140px; padding-left: 15px; padding-right: 15px; margin-left: auto !important;" class="nudgd-btn survey-submit ml-10" @click="createEndUser()">
						{{ __('register_start_btn', 'Ja, nu börjar vi!') }}
					</div>
				</div>
			</div>
		</div>

		<div class="register-container mt-10" v-if="thanks">
			<h2>{{ clientRegister && clientRegister.thanks_title ? clientRegister.thanks_title : __('register_thanks', 'Thank you!') }}</h2>

			<h3 class="mt-5" v-html="clientRegister.thanks_text_below_title || __('register_under_thanks', 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.')"></h3>
		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
	name: 'Vue',

	data() {
		return {
			clientRegister: null,
			clientTitle: null,
			clientId: null,
			firstName: null,
			email: null,
			consent: false,
			errors: [],
			thanks: false,
			processing: false,
			alreadyExists: false,
		}
	},

	mounted() {
		this.$store.state.loading = true
		this.$store.state.globalLanguage = 'sv'

		axios.get(this.$apiUrl + '/api/language/sv').then(res => {
			this.$store.state.translations = res.data.language
		})

		axios.get(this.$apiUrl + '/api/client-register/' + this.$route.path.substr(1).replace('/', '')).then(res => {
			this.clientTitle = res.data.clientTitle
			this.clientId = res.data.clientId
			this.clientRegister = res.data.clientRegister
			this.$store.state.loading = false
		})
	},

	methods: {
		setLanguage(lang) {
		    this.$changeLang(lang)
		},

		createEndUser() {
			if (this.processing) {
				return
			}

			// validation
			this.errors = [
				this.firstName ? null : 'firstName',
				this.email ? null : 'email',
				this.consent === true ? null : 'consent',
			].filter(e => e)

			if (this.errors.length === 0) {
				if ( ! this.clientRegister.finish_url) {
					this.thanks = true
				}

				this.processing = true

				// api
				axios.post(this.$apiUrl + '/api/register', {
					firstName: this.firstName,
					email: this.email,
					clientId: this.clientId,
					recipientSegment: window.location.hostname,
					language: this.$store.state.globalLanguage
				}).catch(() => {
					this.alreadyExists = true
					this.processing = false
				}).then(res => {
					if (res && res.data) {
						this.$store.state.endUser = {slug: res.data.slug}
						this.$metric({'event': 'registration_submit'})
					}

					this.processing = false

					if (this.clientRegister.finish_url) {
						if (this.clientRegister.finish_url.includes('http')) {
							window.location.href = this.clientRegister.finish_url

							return
						} else {
							if (this.clientRegister.finish_url.charAt(0) !== '/') {
								this.clientRegister.finish_url = '/' + this.clientRegister.finish_url
							}

							this.$router.push({path: this.clientRegister.finish_url})
						}
					}

				    // reset after 12 seconds
				    setTimeout(() => {
				    	this.thanks = false
				    	this.firstName = null
				    	this.email = null
				    	this.consent = false
				    }, 12000)
				})
			}
		}
	},
}
</script>
